import script from "./PlAccountMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./PlAccountMenu.vue?vue&type=script&setup=true&lang=js"

import "./PlAccountMenu.vue?vue&type=style&index=0&id=1602e32a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1602e32a"]])

export default __exports__